export * from './loyalty-offers.styled.default';
